// Ask Your Data redux actions.
//
// Replaces the old fetchLLM actions which posted to a broken /signal/llm
// endpoint. Backed by the new /signal/ask + /signal/ask/sessions API
// surface (see core/src/api/signal/management.py).

const namespace = 'SIGNAL_ASK_DATA';

export const ASK_REQUEST  = `${namespace}_ASK_REQUEST`;
export const ASK_SUCCESS  = `${namespace}_ASK_SUCCESS`;
export const ASK_FAILURE  = `${namespace}_ASK_FAILURE`;

export const SESSIONS_REQUEST = `${namespace}_SESSIONS_REQUEST`;
export const SESSIONS_SUCCESS = `${namespace}_SESSIONS_SUCCESS`;
export const SESSIONS_FAILURE = `${namespace}_SESSIONS_FAILURE`;

export const SESSION_LOAD_REQUEST = `${namespace}_SESSION_LOAD_REQUEST`;
export const SESSION_LOAD_SUCCESS = `${namespace}_SESSION_LOAD_SUCCESS`;
export const SESSION_LOAD_FAILURE = `${namespace}_SESSION_LOAD_FAILURE`;

export const SESSION_DELETE_REQUEST = `${namespace}_SESSION_DELETE_REQUEST`;
export const SESSION_DELETE_SUCCESS = `${namespace}_SESSION_DELETE_SUCCESS`;
export const SESSION_DELETE_FAILURE = `${namespace}_SESSION_DELETE_FAILURE`;

export const NEW_SESSION       = `${namespace}_NEW_SESSION`;
export const SELECT_SESSION    = `${namespace}_SELECT_SESSION`;
export const APPEND_PENDING    = `${namespace}_APPEND_PENDING`;
export const CLEAR_ERROR       = `${namespace}_CLEAR_ERROR`;

// ---------------------------------------------------------------------------
// Streaming actions. The saga pushes one of these per SSE event so the
// reducer can update the live message in place.
// ---------------------------------------------------------------------------
export const STREAM_START      = `${namespace}_STREAM_START`;
export const STREAM_TEXT_DELTA = `${namespace}_STREAM_TEXT_DELTA`;
export const STREAM_TOOL_START = `${namespace}_STREAM_TOOL_START`;
export const STREAM_TOOL_END   = `${namespace}_STREAM_TOOL_END`;
export const STREAM_ATTACHMENT = `${namespace}_STREAM_ATTACHMENT`;
export const STREAM_DONE       = `${namespace}_STREAM_DONE`;
export const STREAM_ERROR      = `${namespace}_STREAM_ERROR`;
// Saga trigger: same payload shape as askRequest but kicks off the
// SSE turn. The saga handles all streaming state internally.
export const STREAM_REQUEST    = `${namespace}_STREAM_REQUEST`;

// ---------------------------------------------------------------------------
// One conversation turn.
// payload = { session_id?, question }
export const askRequest = (payload) => ({ type: ASK_REQUEST, payload });
export const askSuccess = (payload) => ({ type: ASK_SUCCESS, payload });
export const askFailure = (payload) => ({ type: ASK_FAILURE, payload });

// Sessions list.
export const fetchSessionsRequest = () => ({ type: SESSIONS_REQUEST });
export const fetchSessionsSuccess = (payload) => ({ type: SESSIONS_SUCCESS, payload });
export const fetchSessionsFailure = (payload) => ({ type: SESSIONS_FAILURE, payload });

// Single-session transcript.
export const loadSessionRequest = (session_id) => ({
  type: SESSION_LOAD_REQUEST, payload: { session_id },
});
export const loadSessionSuccess = (payload) => ({ type: SESSION_LOAD_SUCCESS, payload });
export const loadSessionFailure = (payload) => ({ type: SESSION_LOAD_FAILURE, payload });

// Delete a session.
export const deleteSessionRequest = (session_id) => ({
  type: SESSION_DELETE_REQUEST, payload: { session_id },
});
export const deleteSessionSuccess = (session_id) => ({
  type: SESSION_DELETE_SUCCESS, payload: { session_id },
});
export const deleteSessionFailure = (payload) => ({ type: SESSION_DELETE_FAILURE, payload });

// Local-only actions for UI state.
export const newSession    = () => ({ type: NEW_SESSION });
export const selectSession = (session_id) => ({ type: SELECT_SESSION, payload: { session_id } });
// `attachments` = [{filename, size_bytes}] chips shown on the user bubble.
// `hidden` marks app-initiated turns (setup kickoff): the user bubble is
// persisted as model context but never rendered.
export const appendPending = (question, attachments, hidden = false) => ({
  type: APPEND_PENDING, payload: { question, attachments, hidden },
});
export const clearError    = () => ({ type: CLEAR_ERROR });

// ---------------------------------------------------------------------------
// Streaming
// ---------------------------------------------------------------------------
export const askStreamRequest = (payload) => ({ type: STREAM_REQUEST,    payload });
export const streamStart      = (payload) => ({ type: STREAM_START,      payload });
export const streamTextDelta  = (text)    => ({ type: STREAM_TEXT_DELTA, payload: { text } });
export const streamToolStart  = (payload) => ({ type: STREAM_TOOL_START, payload });
export const streamToolEnd    = (payload) => ({ type: STREAM_TOOL_END,   payload });
export const streamAttachment = (payload) => ({ type: STREAM_ATTACHMENT, payload });
export const streamDone       = (payload) => ({ type: STREAM_DONE,       payload });
export const streamError      = (payload) => ({ type: STREAM_ERROR,      payload });
